import React, { useState } from 'react';
import { useStore } from '../../stores/useStore';

export const MyPage: React.FC = () => {
    const { user, profiles, signOut, updateProfile } = useStore();
    const myProfile = profiles.find((p) => p.id === user?.id);

    const [isEditing, setIsEditing] = useState(false);
    const [editName, setEditName] = useState('');
    const [editPhone, setEditPhone] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const formatPhone = (phone: string) => {
        if (phone.length === 11) return `${phone.slice(0, 3)}-${phone.slice(3, 7)}-${phone.slice(7)}`;
        if (phone.length === 10) return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`;
        return phone;
    };

    const handleStartEdit = () => {
        setEditName(myProfile?.name || '');
        setEditPhone(myProfile?.phone ? formatPhone(myProfile.phone) : '');
        setIsEditing(true);
    };

    const handleSave = async () => {
        if (!user || !editName.trim()) return;
        setIsSaving(true);
        await updateProfile(user.id, editName.trim(), editPhone);
        setIsSaving(false);
        setIsEditing(false);
    };

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '9px 12px',
        border: '1px solid #c4b8a5',
        borderRadius: '10px',
        fontSize: '14px',
        fontFamily: "'Noto Sans KR', sans-serif",
        outline: 'none',
        backgroundColor: 'white',
        boxSizing: 'border-box',
        color: '#2c2c2c',
    };

    return (
        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {/* 프로필 카드 */}
            <div style={{ backgroundColor: '#f4f1ea', border: '1px solid #c4b8a5', borderRadius: '16px', padding: '20px' }}>
                <div style={{
                    width: '52px', height: '52px',
                    backgroundColor: '#1e3a5f',
                    borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    marginBottom: '14px',
                    fontSize: '22px',
                }}>
                    👤
                </div>

                {isEditing ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <div>
                            <label style={{ fontSize: '11px', fontWeight: 700, color: '#5a5a5a', display: 'block', marginBottom: '4px', letterSpacing: '0.3px' }}>
                                이름
                            </label>
                            <input
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                                placeholder="이름"
                                style={inputStyle}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: '11px', fontWeight: 700, color: '#5a5a5a', display: 'block', marginBottom: '4px', letterSpacing: '0.3px' }}>
                                연락처
                            </label>
                            <input
                                value={editPhone}
                                onChange={(e) => setEditPhone(e.target.value)}
                                placeholder="010-0000-0000"
                                style={inputStyle}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                            <button
                                onClick={handleSave}
                                disabled={isSaving || !editName.trim()}
                                style={{
                                    flex: 1, padding: '10px',
                                    backgroundColor: isSaving ? '#a09890' : '#1e3a5f',
                                    color: 'white', border: 'none', borderRadius: '10px',
                                    fontSize: '13px', fontWeight: 700, cursor: isSaving ? 'default' : 'pointer',
                                    fontFamily: "'Noto Sans KR', sans-serif",
                                }}
                            >
                                {isSaving ? '저장 중...' : '저장'}
                            </button>
                            <button
                                onClick={() => setIsEditing(false)}
                                disabled={isSaving}
                                style={{
                                    flex: 1, padding: '10px',
                                    backgroundColor: 'white',
                                    color: '#5a5a5a', border: '1px solid #c4b8a5', borderRadius: '10px',
                                    fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                                    fontFamily: "'Noto Sans KR', sans-serif",
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <p style={{ fontSize: '20px', fontWeight: 700, color: '#1e3a5f', marginBottom: '6px' }}>
                            {myProfile?.name || '—'}
                        </p>
                        <p style={{ fontSize: '14px', color: '#5a5a5a', fontFamily: "'Roboto Mono', monospace", marginBottom: '14px' }}>
                            {myProfile?.phone ? formatPhone(myProfile.phone) : user?.email?.replace('@beomyang.local', '') || '—'}
                        </p>
                        <button
                            onClick={handleStartEdit}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: 'white',
                                color: '#1e3a5f',
                                border: '1px solid #1e3a5f',
                                borderRadius: '10px',
                                fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                                fontFamily: "'Noto Sans KR', sans-serif",
                            }}
                        >
                            정보 수정
                        </button>
                    </div>
                )}
            </div>

            {/* 가입자 목록 */}
            <div style={{ backgroundColor: '#f4f1ea', border: '1px solid #c4b8a5', borderRadius: '16px', overflow: 'hidden' }}>
                <div style={{
                    padding: '12px 16px',
                    borderBottom: '1px solid #c4b8a5',
                    fontSize: '12px', fontWeight: 700, color: '#5a5a5a', letterSpacing: '0.5px',
                }}>
                    가입자 목록 ({profiles.length}명)
                </div>
                {profiles.length === 0 ? (
                    <div style={{ padding: '16px', fontSize: '13px', color: '#a09890', textAlign: 'center' }}>
                        가입자가 없습니다
                    </div>
                ) : (
                    profiles.map((p, idx) => (
                        <div
                            key={p.id}
                            style={{
                                padding: '12px 16px',
                                borderBottom: idx === profiles.length - 1 ? 'none' : '1px solid #e8e0d5',
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span style={{
                                    width: '28px', height: '28px',
                                    backgroundColor: p.id === user?.id ? '#1e3a5f' : '#e8e0d5',
                                    color: p.id === user?.id ? 'white' : '#5a5a5a',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '12px', fontWeight: 700, borderRadius: '50%', flexShrink: 0,
                                }}>
                                    {p.name.charAt(0)}
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: p.id === user?.id ? 700 : 400, color: '#2c2c2c' }}>
                                    {p.name}
                                    {p.id === user?.id && (
                                        <span style={{ fontSize: '11px', color: '#1e3a5f', marginLeft: '6px', fontWeight: 400 }}>나</span>
                                    )}
                                </span>
                            </div>
                            <span style={{ fontSize: '12px', color: '#a09890', fontFamily: "'Roboto Mono', monospace" }}>
                                {formatPhone(p.phone)}
                            </span>
                        </div>
                    ))
                )}
            </div>

            {/* 로그아웃 */}
            <button
                onClick={signOut}
                style={{
                    width: '100%', padding: '13px',
                    backgroundColor: 'white',
                    color: '#c75c2e',
                    border: '1px solid #c75c2e',
                    borderRadius: '10px',
                    fontSize: '14px', fontWeight: 700,
                    cursor: 'pointer',
                    fontFamily: "'Noto Sans KR', sans-serif",
                    marginTop: '4px',
                }}
            >
                로그아웃
            </button>
        </div>
    );
};
